export default __webpack_public_path__ + "static/media/storageMonitor.e2bf7b11.png";